import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteOperacao,
  findOperacao,
  recordFiltering,
} from '~/store/modules/operacao/actions';

import Form from './form';

function OperacaoList() {
  const redux = useSelector((state) => state.operacao);

  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idoperacao',
        label: t('s.cadastro.operacao.idoperacao'),
        filter: { type: 'text' },
      },
      {
        id: 'descricaooperacao',
        label: t('s.cadastro.operacao.descricaooperacao'),
        filter: { type: 'text' },
      },
      {
        id: 'statusoperacao',
        label: t('s.cadastro.motorista.statusmotorista'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findOperacao}
      remove={deleteOperacao}
      form={Form}
      keys="idoperacao"
      detach="descricaooperacao"
    />
  );
}

export default OperacaoList;
